module.exports = __webpack_public_path__ + "3f96dd900559543c85153619ed6267b8.pdf";